<template>
  <div v-if="propIdMensalista"
       class="mt-3">
    <span>Périodo</span>
    <div class="row">
      <div class="col-2">
        <b-form-input v-model="dataInicial"
                      v-validate="`required`"
                      type="date"
                      name="dataInicial"
                      :class="{ 'is-invalid': errors.has('dataInicial') }"
                      class="form-control form-control" />
        <small v-if="errors.has('dataInicial')"
               class="text-danger">{{ errors.first('dataInicial') }}</small>
      </div>
      <span class="mt-2">até</span>
      <div class="col-2">
        <b-form-input v-model="dataFinal"
                      v-validate="`required`"
                      type="date"
                      name="dataFinal"
                      :class="{ 'is-invalid': errors.has('dataFinal') }"
                      class="form-control form-control" />
        <small v-if="errors.has('dataFinal')"
               class="text-danger">{{ errors.first('dataFinal') }}</small>
      </div>
      <div class="col-2">
        <b-button variant="outline-primary"
                  class="w-75"
                  @click="filtrar">
          Filtrar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
  //Services
  import MensalistaService from '../mensalistaService'

  export default ({
    name: 'FiltroDataMensalistas',
    props: {
      propIdMensalista: {type: Object, default: null}
    },
    data () {
      return {
        statusPedidos: false,
        dataInicial: null,
        dataFinal: null
      }
    },
    methods: {
      async filtrar () {
        this.$validator.validate().then(async resp => {
          if (resp) {
            if (this.dataInicial > this.dataFinal) {
              return displayMessage('error', 'Erro!', 'A data inicial não deve ser maior que a final, corrija para continuar')
            }
            this.getRelatorioPDF ()
          }
        })      
      },
      async getRelatorioPDF () {
        loader ({text: 'Buscando pedidos', active: true})
        try {
          const paylod = {
            id: this.propIdMensalista.mensalista_id,
            dataInicial: this.dataInicial,
            dataFinal: this.dataFinal,
            statusPedidos: this.statusPedidos
          }
          const mensalistaPedidos = await MensalistaService.buscarById(paylod)
          this.$emit('getServicosRealizados', mensalistaPedidos, paylod)
        } catch (err) {
          console.log('FiltroMensalista', err)
        } finally {
          loader({text: null, active: false})
        }
      }
    }
  })
</script>

<style scoped>
.label {
  font-size: 1.2rem;
}
.inputs-data {
  max-width: 18%;
  padding-top: 24px;
  padding-bottom: 24px;
  font-size: 1.1rem;
}
.btn-filtrar {
  margin-left: 40px;
  font-size: 1.1rem;
  padding-left: 20px;
  padding-right: 20px;
  transform: scale(1.2);
}
</style>
